export default [
  {
    name: 'video-id',
    path: 'teacher/:teacherId/videos/:id',
    component: () => import(/* webpackChunkName: "video-id" */ '@/views/Video/TeacherVideo'),
    meta: {
      keepAlive: false
    }
  },
  {
    name: 'character-id',
    path: 'teacher/:teacherId/course/:courseId/characters/:id',
    component: () => import(/* webpackChunkName: "character-id" */ '@/views/Video/CharacterVideo'),
    meta: {
      keepAlive: false
    }
  }
]
